import { Action } from '@ngrx/store';

export const GLOBAL_LOCK_SUCCESS = '[Customer] Global Lock Success';

export class GlobalLockSuccessAction implements Action {
  readonly type = GLOBAL_LOCK_SUCCESS;
}





// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GlobalLockSuccessAction.ts